export default function calculateNcz30dPercentage(amount, price_last_30) {
  if(amount && price_last_30 && typeof price_last_30 === 'number' && price_last_30 > 0 && price_last_30 > amount){
    return Math.floor((price_last_30 - amount) / price_last_30 * 100);
  }
  return null;
}